import { computed } from 'vue';
import { CustomProductDto } from '@studyportals/campaign-management-api-interface';
import { IUnsavedCustomProductData } from '@/models/custom-products.interface';
import store from '@/store';

class CustomBudgetPresenter {
	public budgetLeftFormatted = computed((): string => {
		return this.formatNumber(this.budgetLeft.value);
	});

	public budgetUsedFormatted = computed((): string => {
		return this.formatNumber(this.budgetUsed.value);
	});

	public budgetCustomFormatted = computed((): string => {
		return this.formatNumber(this.budgetCustom.value);
	});

	public budgetTotalFormatted = computed((): string => {
		return this.formatNumber(this.budgetTotal.value);
	});

	public isBudgetUsedNegative = computed((): boolean => {
		return this.budgetUsed.value < 0;
	});

	public isBudgetLeftNegative = computed((): boolean => {
		return this.budgetLeft.value < 0;
	});

	private budgetUsed = computed((): number => {
		const budgetPrices = this.customProducts.value.map((product) => product.price);
		return budgetPrices.reduce((sum, value) => sum + value, 0);
	});

	private budgetTotal = computed((): number => {
		return this.budgetListing.value + this.budgetCustom.value;
	});

	private budgetLeft = computed((): number => {
		return this.budgetCustom.value - this.budgetUsed.value;
	});

	private budgetCustom = computed((): number => {
		const budgetCustom = store.getters.budgetCustom();
		return typeof budgetCustom === 'number' && !isNaN(budgetCustom) ? budgetCustom : 0;
	});

	private budgetListing = computed((): number => {
		const budgetListing = store.getters.budgetListing();
		return typeof budgetListing === 'number' && !isNaN(budgetListing) ? budgetListing : 0;
	});

	private customProducts = computed((): (IUnsavedCustomProductData | CustomProductDto)[] => {
		return store.getters.customProducts();
	});

	public formatNumber(value: number): string {
		value = this.makeNumberAbsolute(value);
		return value.toLocaleString('en-GB');
	}

	private makeNumberAbsolute(value: number): number {
		return Math.abs(value);
	}
}

export default new CustomBudgetPresenter();
